'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var TimeOfDay = /** @class */ (function () {
    function TimeOfDay() {
        this.MORNING = 'morning';
        this.AFTERNOON = 'afternoon';
        this.EVENING = 'evening';
    }
    return TimeOfDay;
}());
exports.TimeOfDay = TimeOfDay;
var TimeOfDayBounds = /** @class */ (function () {
    function TimeOfDayBounds() {
        this.MORNING = 12;
        this.AFTERNOON = 17;
        this.EVENING = 23;
    }
    return TimeOfDayBounds;
}());
exports.TimeOfDayBounds = TimeOfDayBounds;
var DateDefaultsConst = /** @class */ (function () {
    function DateDefaultsConst() {
        this.DATE_FORMAT = 'YYYY-MM-DD';
        this.TIME_FORMAT = 'HH:mm:ss.SSS';
        this.DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
    }
    return DateDefaultsConst;
}());
exports.DateDefaultsConst = DateDefaultsConst;
//# sourceMappingURL=date-time.js.map